import client from '../client';

export async function listPermissions() {
  return client.get(`/cms/api/v1/profile/permissions`);
}
